<template>
  <div class="result">
    <div class="result_nav">
      <navbar
        :titletext="pageTitle"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row class="content">
        <van-col span="24" class="icon">
          <img
            v-if="type == 2"
            src="../../../assets/purchaseSupplier/contract/success.png"
          />
          <img
            v-if="type != 2"
            src="../../../assets/purchaseSupplier/contract/fail.png"
          />
        </van-col>
        <van-col span="24" class="tips">{{ tips }}</van-col>
        <van-col span="24" class="remark">{{ remark }}</van-col>

        <van-col span="24" v-if="type != 2">
          <btn
            :btntext="'重新申请'"
            :btnwidth="'30.9rem'"
            :height="'5rem'"
            :bgcolor="'linear-gradient(to right, #FC740C, #F41A3C)'"
            :btnmargin="'6.1rem 0 0 0'"
            :borderradius="'2.5rem'"
            :btncolor="'#fff'"
            :fontsize="'1.7rem'"
            @btnClick="goBack"
          />
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      pageTitle: "",
      tips: "",
      remark: "",
      type: "", //1合同审核结果  2签名结果  3平台审核结果
    };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  created() {
    this.type = this.$route.query.type;
    if (this.type == 1) {
      this.pageTitle = "合同审核结果";
      this.tips = "审核被驳回";
      this.remark = "驳回原因：不想通过";
    }
    if (this.type == 2) {
      this.pageTitle = "签名结果";
      this.tips = "已成功签名";
      this.remark = "我们将在7个工作日内审核您的申请，请耐心等待";
    }
    if (this.type == 3) {
      this.pageTitle = "平台审核结果";
      this.tips = "审核被驳回";
      this.remark = "驳回原因：不想通过";
    }
  },
  methods: {
    goBack() {
      if (this.type != 2) {
        this.params("", "", "goBack");
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.result {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .result_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    padding: 10.3rem 0 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .content {
      text-align: center;
      background: #fff;
      margin-bottom: 1.6rem;
      padding: 4.1rem 3.6rem 3.6rem;
      box-sizing: border-box;

      .icon {
        text-align: center;

        img {
          width: 5.4rem;
          margin-bottom: 2rem;
        }
      }

      .tips {
        color: #333;
        font-size: 1.5rem;
        line-height: 2.2rem;
      }

      .remark {
        color: #666;
        font-size: 1.5rem;
        line-height: 2.1rem;
        margin-top: 1.7rem;
      }
    }
  }
}
</style>